module.exports = __webpack_public_path__ + "img/MINUS.33b57e64.svg";